import React from 'react';

import { getCityCode } from '../helpers';
import type { Flight } from '../flowTypes';
import useFlightPageContext from '../static-db';

type Props = {
  flight: Flight,
};

const FlightSummaryCard = ({ flight }: Props) => {
  const {
    departure,
    arrival,
    arrivalTime,
    departureTime,
    refundable,
    currency,
    flightNo,
    totalAmount,
  } = flight;
  const { sectors } = useFlightPageContext();
  const getCityCodeFromSectors = getCityCode(sectors);

  return (
    <div className="picked-card">
      <div className="d-flex justify-content-between align-items-center">
        <div className="fl-image">
          <img src="/img/airlines.png" alt="logo" />
        </div>
        <div className="fl-name">
          <h4>Summit Air</h4>
          <p>{flightNo}</p>
        </div>
        <div className="fl-time-place">
          <div className="d-flex justify-content-between fl-time">
            <h4>
              {departureTime} - {arrivalTime}
            </h4>
          </div>
          <div className="d-flex justify-content-between fl-place">
            <p>{getCityCodeFromSectors(departure)}</p>
            <p>{getCityCodeFromSectors(arrival)}</p>
          </div>
        </div>
        <div className="fl-price">
          <h4>
            {currency} {totalAmount.toLocaleString()}
          </h4>
          <p>
            {refundable === 'T'
              ? 'Refundable'
              : refundable === 'F'
              ? 'Non-Refundable'
              : null}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FlightSummaryCard;



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/FlightSummaryCard.js